import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login/Login';
import DashboardFull from './components/Dashboard/DashboardFull';
import SettingsMultiple from './components/Settings/SettingsMultiple';
import AdminSection from './components/Admin/AdminSection';
import SmtpSettings from './components/Admin/SmtpSettings';
import SpellStatsDashboard from './components/Admin/SpellStatsDashboard';
import MailPage from './components/Mail/MailPage';
import EmailSettings from './components/Mail/EmailSettings';
import TicketsDashboard from './components/Tickets/TicketsDashboard';
import './App.css';

// Protected Route component
const ProtectedRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>Загрузка...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <DashboardFull />
            </ProtectedRoute>
          } />
          <Route path="/settings" element={
            <ProtectedRoute>
              <SettingsMultiple />
            </ProtectedRoute>
          } />
          <Route path="/admin/users" element={
            <ProtectedRoute>
              <AdminSection mode="users" />
            </ProtectedRoute>
          } />
          <Route path="/admin/groups" element={
            <ProtectedRoute>
              <AdminSection mode="groups" />
            </ProtectedRoute>
          } />
          <Route path="/admin/trash" element={
            <ProtectedRoute>
              <AdminSection mode="trash" />
            </ProtectedRoute>
          } />
          <Route path="/admin/broadcast" element={
            <ProtectedRoute>
              <AdminSection mode="broadcast" />
            </ProtectedRoute>
          } />
          <Route path="/admin/smtp" element={
            <ProtectedRoute>
              <SmtpSettings />
            </ProtectedRoute>
          } />
          <Route path="/admin/spell" element={
            <ProtectedRoute>
              <SpellStatsDashboard />
            </ProtectedRoute>
          } />
          <Route path="/admin/tickets" element={
            <ProtectedRoute>
              <TicketsDashboard />
            </ProtectedRoute>
          } />
          <Route path="/mail" element={
            <ProtectedRoute>
              <MailPage />
            </ProtectedRoute>
          } />
          <Route path="/settings/email" element={
            <ProtectedRoute>
              <EmailSettings />
            </ProtectedRoute>
          } />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;

